import { Trans, useLingui } from '@lingui/react/macro'
import { Switch } from 'designSystem/components/Switch'
import { Text } from 'designSystem/components/Text'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from 'designSystem/components/Tooltip'
import React from 'react'
import styled from 'styled-components'

const BetaSwitchLabel = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
`

interface DocChatBetaSwitchProps {
  enabled: boolean
  onToggle: (enabled: boolean) => void
}

export function DocChatBetaSwitch({
  enabled,
  onToggle,
}: DocChatBetaSwitchProps): React.ReactElement {
  const { t } = useLingui()

  return (
    <Tooltip delayDuration={300} disableHoverableContent>
      <TooltipTrigger asChild>
        <BetaSwitchLabel>
          <Switch
            size='sm'
            checked={enabled}
            aria-label={t`Beta`}
            onCheckedChange={onToggle}
          />
          <Text variant='body' wrap='nowrap'>
            <Trans>Beta</Trans>
          </Text>
        </BetaSwitchLabel>
      </TooltipTrigger>
      <TooltipContent side='top' width='measure'>
        <Trans>
          Turns on the new Doc Chat tools available at this site. Turn it off to
          use standard Doc Chat.
        </Trans>
      </TooltipContent>
    </Tooltip>
  )
}
